// eslint-disable-next-line no-unused-vars
import moment from 'moment';
export var fromMomentToUTCNumber = function (value) { return moment(value).utc().unix() * 1000; };
export var fromNumberToUTCMoment = function (value) {
    return moment(parseInt(value)).utc();
};
export var removeTimeFromStringMoment = function (value) { return moment(value).startOf('day').format(); };
export var setTimeToInitOf = function (value, period) {
    switch (period.toUpperCase()) {
        case 'DAY':
            return moment(value).startOf('day').format();
        case 'WEEK':
            return moment(value).startOf('week').format();
        case 'MONTH':
            return moment(value).startOf('month').format();
        default:
            return moment(value).startOf('year').format();
    }
};
export var substractTime = function (value, period, amountTime) {
    switch (period.toUpperCase()) {
        case 'SECONDS':
            return moment(value).subtract('seconds', amountTime).format();
        case 'DAYS':
            return moment(value).subtract('days', amountTime).format();
        case 'WEEKS':
            return moment(value).subtract('weeks', amountTime).format();
        case 'MONTHS':
            return moment(value).subtract('months', amountTime).format();
        default:
            return moment(value).subtract('years', amountTime).format();
    }
};
//# sourceMappingURL=Time.js.map